/**
 * The hand-off from the topbar's Ask AI prompt to the Ask AI page.
 *
 * The topbar navigates to `/ask-ai` with this in the history entry's
 * `location.state`:
 *
 *   askAiPrompt    { text, dealId, nonce } -- the question to send, the deal
 *                  to scope it to (null for no deal context), and a nonce so
 *                  the same question asked twice is still two requests.
 *                  Consumed once: the Ask AI page replaces the entry without
 *                  it, so a reload or Back/Forward does not ask again.
 *   askAiReturnTo  { path, label } -- where the prompt was asked from, for the
 *                  topbar's "Back to ..." button. Kept on the entry.
 *
 * History state rather than query params: the prompt is free text the user
 * typed, which has no business in the URL bar, in analytics or in a shared
 * link.
 */

export const ASK_AI_PATH = '/ask-ai';

export const askAiLocation = ({ text, dealId, returnTo }) => ({
  pathname: ASK_AI_PATH,
  state: {
    askAiPrompt: { text, dealId: dealId || null, nonce: Date.now() },
    askAiReturnTo: returnTo,
  },
});
